import { Scan } from "../models/scan/scan";
import { BarGraphEntry } from "../components/dashboard/pages/scan/graph/bar-graph/barGraphEntry";
import { Category } from "../models/category/category";
import { Mode } from "./mode";
import { convertModeToText } from "./convertModeToText";
import { TFunction } from "i18next";

export function formatScanToBarGraphData(
  scan: Scan,
  activeCategory: Category,
  mode: Mode,
  t: TFunction
): BarGraphEntry[] {
  const entries: BarGraphEntry[] = [];
  if (!!scan) {
    const stepResults = scan.scanStepResults.filter(
      (s) => s.step.categoryId === activeCategory.id
    );

    if (stepResults.length) {
      entries.push(
        ...stepResults.map(
          (stepResult) =>
            ({
              step: stepResult.step.name,
              [convertModeToText(mode, t)]: Number(
                stepResult.scaledScore.toPrecision(2)
              ),
            } as any)
        )
      );
    }
  }

  return entries;
}
